/* import __COLOCATED_TEMPLATE__ from './sent.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();